// extracted by mini-css-extract-plugin
module.exports = {"FaqAskQuestion":"oj_a bhc_px bhc_a bhc_w","FaqAskQuestion__outdated":"oj_b bhc_ul bhc_vz"};